import Typography from "@mui/material/Typography";

import { TranslateFooterHTML, TranslationKey } from "components/Footer/i18n";
import { FooterHref } from "components/Footer/model";
import { Language } from "utils/language";

import { FooterLink } from "./FooterLink";
import { linkGroupStyles as styles } from "./LinkGroup.styles";

interface LinkWithSuperTitleNodeProps {
  href: FooterHref;
  newTab?: boolean;
  pageLanguage: Language;
  superTitleKey: TranslationKey;
  titleKey: TranslationKey;
  translate: (key: TranslationKey) => string;
}

export const LinkWithSuperTitleNode = ({
  href,
  newTab,
  pageLanguage,
  superTitleKey,
  titleKey,
  translate,
}: LinkWithSuperTitleNodeProps) => {
  return (
    <Typography key={titleKey} variant="body1" css={styles.linkWithSuperTitle}>
      {translate(superTitleKey)}
      <br />
      <FooterLink
        key={titleKey}
        component="a"
        dataTestId={titleKey}
        href={href[pageLanguage] || href.en}
        css={styles.linkText}
        newTab={!!newTab}
      >
        <TranslateFooterHTML keyName={titleKey} />
      </FooterLink>
    </Typography>
  );
};
